export default function (path){
    let tmp = path.match(/(_n|objectId=)(\d+)/i);
    return tmp[2];
}